import type { ClassValue } from 'clsx'
import clsx from 'clsx'

/**
 * Склейка классов. Без `tailwind-merge`: конфликты классов в этом проекте
 * решаются композицией вариантов, а не перезаписью «последний победил».
 */
export function cn(...values: ClassValue[]): string {
  return clsx(values)
}
